import { actionCreator } from 'utils';
import * as PlanningTypes from '../types/planningTypes';

// L O A D   P L A N N I N G
export function loadPlanning() {
    return {
        type: PlanningTypes.LOAD_PLANNING,
    };
}

export function loadPlanningRes(data) {
    return {
        type: actionCreator(PlanningTypes.LOAD_PLANNING, 'res'),
        data,
    };
}

export function loadPlanningErr() {
    return {
        type: actionCreator(PlanningTypes.LOAD_PLANNING, 'err'),
    };
}
// L O A D   P L A N N I N G


// F I L T E R S
export function setPlanningFilter(key, value) {
    return {
        type: PlanningTypes.SET_PLANNING_FILTER,
        key,
        value,
    };
}

export function resetPlanningFilters() {
    return {
        type: PlanningTypes.RESET_PLANNING_FILTERS,
    };
}
// F I L T E R S


// P L A N   F O R M   V E R S I O N
export function prepareFormVersion(data) {
    return {
        type: PlanningTypes.PREPARE_FORM_VERSION,
        data,
    };
}

export function planFormVersion(data) {
    return {
        type: PlanningTypes.PLAN_FORM_VERSION,
        data,
    };
}

export function planFormVersionRes() {
    return {
        type: actionCreator(PlanningTypes.PLAN_FORM_VERSION, 'res'),
    };
}

export function planFormVersionErr() {
    return {
        type: actionCreator(PlanningTypes.PLAN_FORM_VERSION, 'err'),
    };
}
// P L A N   F O R M   V E R S I O N


// E D I T   F O R M   V E R S I O N
export function editFormVersion(data) {
    return {
        type: PlanningTypes.EDIT_FORM_VERSION,
        data,
    };
}

export function editFormVersionRes() {
    return {
        type: actionCreator(PlanningTypes.EDIT_FORM_VERSION, 'res'),
    };
}

export function editFormVersionErr() {
    return {
        type: actionCreator(PlanningTypes.EDIT_FORM_VERSION, 'err'),
    };
}
// E D I T   F O R M   V E R S I O N


// S I M U L A T E   F O R M   V E R S I O N   P L A N N I N G
export function simulateFormVersionPlanning(data) {
    return {
        type: PlanningTypes.SIMULATE_FORM_VERSION_PLANNING,
        data,
    };
}

export function simulateFormVersionPlanningRes(data) {
    return {
        type: actionCreator(PlanningTypes.SIMULATE_FORM_VERSION_PLANNING, 'res'),
        data,
    };
}

export function simulateFormVersionPlanningErr() {
    return {
        type: actionCreator(PlanningTypes.SIMULATE_FORM_VERSION_PLANNING, 'err'),
    };
}

export function removeNewEvents() {
    return {
        type: PlanningTypes.REMOVE_NEW_EVENTS,
    };
}
// S I M U L A T E   F O R M   V E R S I O N   P L A N N I N G


// A D D   R E S E R V A T I O N
export function addReservation(data) {
    return {
        type: PlanningTypes.ADD_RESERVATION,
        data,
    };
}

export function addReservationRes() {
    return {
        type: actionCreator(PlanningTypes.ADD_RESERVATION, 'res'),
    };
}

export function addReservationErr() {
    return {
        type: actionCreator(PlanningTypes.ADD_RESERVATION, 'err'),
    };
}
// A D D   R E S E R V A T I O N


// D E L E T E   R E S E R V A T I O N
export function deleteReservation(data) {
    return {
        type: PlanningTypes.DELETE_RESERVATION,
        data,
    };
}

export function deleteReservationRes() {
    return {
        type: actionCreator(PlanningTypes.DELETE_RESERVATION, 'res'),
    };
}

export function deleteReservationErr() {
    return {
        type: actionCreator(PlanningTypes.DELETE_RESERVATION, 'err'),
    };
}
// D E L E T E   R E S E R V A T I O N


// B U L K   F O R M S
export function prepareBulkForms(forms) {
    return {
        type: PlanningTypes.PREPARE_BULK_FORMS,
        forms,
    };
}
// B U L K   F O R M S

// V E R I F Y   M U L T I P L E   F O R M   V E R S I O N S
export function verifyMultipleFormVersions(data) {
    return {
        type: PlanningTypes.VERIFY_MULTIPLE_FORM_VERSIONS,
        data,
    };
}

export function planBulkFormVersions(data) {
    return {
        type: PlanningTypes.PLAN_BLUK_FORM_VERSIONS,
        data,
    };
}
// V E R I F Y   M U L T I P L E   F O R M   V E R S I O N S

export function displayRedirectionButton(data) {
    return {
        type: PlanningTypes.DISPLAY_REDIRECTION_BUTTON,
        data,
    };
}

export function setCalculationStatus(status) {
    return {
        type: PlanningTypes.SET_CALCULATION_STATUS,
        status,
    };
}

export function setExtraParams(payload) {
    return {
        type: PlanningTypes.SET_EXTRA_PARAMS,
        payload,
    };
}

export function toggleReplanGroupedFVS(payload) {
    return {
        type: PlanningTypes.TOGGLE_REPLAN_GROUPED_FVS,
        payload,
    };
}

export function toggleEditReservation(payload) {
    return {
        type: PlanningTypes.TOGGLE_EDIT_RESERVATION,
        payload,
    };
}

// E D I T   R E S E R V A T I O N
export function editReservation(data) {
    return {
        type: PlanningTypes.EDIT_RESERVATION,
        data,
    };
}

export function editReservationRes() {
    return {
        type: actionCreator(PlanningTypes.EDIT_RESERVATION, 'res'),
    };
}

export function editReservationErr() {
    return {
        type: actionCreator(PlanningTypes.EDIT_RESERVATION, 'err'),
    };
}
// E D I T   R E S E R V A T I O N
